<template>
    <div class="popup_scroll_wrp">
        <div class="demo_f_request_info_popup">
            <div class="demo_f_request_info_center">
                <div class="demo_f_request_info_modal">
                    <div class="demo_f_request_info_body text-center">
                        <h4 class="demo_f_request_info_title">Are you sure you want to send feedback link?</h4>
                        <div class="btn_group mt-4">
                            <button class="btn btn-success" @click="demoForRequestSubmitMethod"
                                :disabled="submitted">Yes</button>
                            <button class="btn btn-danger ml-3" @click="closeDemoRequestInfoPopup">No</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
/*eslint-disable */
import toast from '@/services/toast';
import { bus } from '@/main';
export default {
    name: 'feedback-link-send-popup',
    components: {},
    props: ['demoReqID'],
    data() {
        return {
            submitted: false
        }
    },
    computed: {

    },
    mounted() {

    },
    methods: {
        closeDemoRequestInfoPopup() {
            bus.$emit('feedbackLinkPopupStateBus', false);
            document.body.classList.remove('body_right_scroll_remove');
        },
        demoForRequestSubmitMethod() {
            this.$validator.validateAll().then((result) => {
                if (result) {
                    this.submitted = true
                    let data = {
                        demo_id: this.demoReqID,
                    }
                    this.$store.dispatch('demoFeedbackRequestAction', data)
                        .then((res) => {
                            this.closeDemoRequestInfoPopup();
                            this.$store.dispatch('getCompletedAllDemoRequestListAction');
                            toast.success(res.data.msg || 'Request processed successfully.');
                            this.submitted = false;
                        }).catch((err) => {
                            this.submitted = false;
                            toast.error(err.data.message || err.data.msg);
                        })
                    return;
                }
            })
        },
    }
}
</script>

<style lang="scss" scoped>
.popup_scroll_wrp {
    position: fixed;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    z-index: 1000;
    background: rgba(0, 0, 0, 0.92);
    width: 100%;
    font-family: 'MyriadProRegular', 'Lato', sans-serif;
    color: #ffffff;
    min-height: 100dvh;
    width: 100%;
    overflow-y: auto;

    &::-webkit-scrollbar {
        width: 8px;
        background: transparent;
    }

    &::-webkit-scrollbar-thumb {
        background-color: #333333;
    }

    .demo_f_request_info_popup {
        display: table;
        width: 100%;
        height: 100%;

        .demo_f_request_info_center {
            display: table-cell;
            vertical-align: middle;
        }

        .demo_f_request_info_modal {
            background: #000;
            max-width: 580px;
            width: 100%;
            margin: 0px auto;
            border-radius: 5px;
            font-family: 'MyriadProRegular', 'Lato', sans-serif;
            color: #ffffff;
            -webkit-box-shadow: 0px 0px 13px rgba(255, 213, 0, 0.6);
            box-shadow: 0px 0px 13px rgba(255, 213, 0, 0.6);
        }

        .demo_f_request_info_body {
            padding: 20px;

            .btn_group {
                .btn {
                    min-width: 100px;
                    -webkit-box-shadow: none !important;
                    box-shadow: none !important;
                    border: none;

                    &:hover {
                        background: #ffe738 !important;
                        color: #22292f !important;
                    }

                    &.btn-success {
                        background: rgba(33, 228, 0, 0.5);
                    }

                    &.btn-danger {
                        background: rgba(255, 18, 18, 0.5);
                    }
                }
            }
        }
    }

    .demo_f_request_info_title {
        font-size: 20px;
        color: #ffffff;
        font-family: 'MyriadProRegular', 'Lato', sans-serif;
        margin: 0px;
    }
}
</style>